import React, {Fragment, useEffect, useRef, useState} from "react";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import SimpleFilter from "../../ShareElements/Select/MultiSelect";
import SearchSelect from "../../Vacancies/Components/SharedElements/SearchSelect";
import Switch from "../../ShareElements/TextInput/Switch";
import BookmarkIcon from "../../../../../Assets/Images/bookmark.svg";
import { NavLink } from "react-router-dom";
import SkillsModal from "./SkillsModal";
import { Config } from "../../../../../Config";
import axios from "axios";
import { formatDate } from "../../../../../Helper_functions";
import Collapsible from "react-collapsible";

const Head = (props) => {
  const [Skills, setSkills] = useState([]);
  const [MobileFilterIsOpen, setMobileFilterIsOpen] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [ShowMore, setShowMore] = useState(false);

  const DescriptionRef = useRef(null);
  const DescriptionWrapperRef = useRef(null);

  useEffect(() => {
    createSkills();
  }, []);

  useEffect(() => {
    if(DescriptionRef.current && DescriptionWrapperRef.current) {
      const descriptionRefHeight = DescriptionRef.current.offsetHeight

      if (descriptionRefHeight > 110) {
        DescriptionWrapperRef.current.style.height = `${DescriptionRef.current.offsetHeight + 16}px`
      } else {
        DescriptionWrapperRef.current.style.height = '110px'
      }
    }
  }, [ShowMore])

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const createSkills = () => {
    let Skills = [];
    props.Details.requiredSkills.map((Skill) => {
      Skills.push(Skill.title);
    });
    setSkills(Skills);
  };

  const displayTitle = () => {
    if (props.IsJob) {
      return <h1 className="jpa-title">{props.Details.position.title}</h1>;
    }
    if (props.IsProject) {
      return <h1 className="jpa-title">{props.Details.project.title}</h1>;
    }
    if (props.IsActivity) {
      return <h1 className="jpa-title">{props.Details.activity.title}</h1>;
    }
  };
  const displayGlobalCode = () => {
    if (props.IsJob && props.Details.position.globalPositionCode) {
      return (
        <p className="small-info">
          {"(" + props.Details.position.globalPositionCode + ")"}
        </p>
      );
    }
    if (props.IsProject && props.Details.project.globalProjectCode) {
      return (
        <h1 className="small-info">
          {"(" + props.Details.project.globalProjectCode + ")"}
        </h1>
      );
    }
    if (props.IsActivity && props.Details.activity.globalActivityCode) {
      return (
        <h1 className="small-info">
          {"(" + props.Details.activity.globalActivityCode + ")"}
        </h1>
      );
    }
  };
  const displayLocation = () => {
    if (props.IsJob) {
      return <p className="jpa-location">{props.Details.position.workCity}</p>;
    }
    if (props.IsProject) {
      return <p className="jpa-location">{props.Details.project.workCity}</p>;
    }
    if (props.IsActivity) {
      return <p className="jpa-location">{props.Details.activity.workCity}</p>;
    }
  };
  const displayStatus = () => {
    if (props.IsJob) {
      if (props.Details.position.recruitmentStatus === null) {
        return (
          <p className="recruitment-status not-started">
            {translateText("not_started")}
          </p>
        );
      } else if (props.Details.position.recruitmentStatus === "IN_PROGRESS") {
        return (
          <p className="recruitment-status in-progress-item">
            {translateText("in_progress")}
          </p>
        );
      } else if (props.Details.position.recruitmentStatus === "NEW") {
        return (
          <p className="recruitment-status new-item">{translateText("new")}</p>
        );
      } else if (props.Details.position.recruitmentStatus === "POPULAR") {
        return (
          <p className="recruitment-status popular-item">
            {translateText("popular")}
          </p>
        );
      } else if (props.Details.position.recruitmentStatus === "ACCEPTED") {
        return (
          <p className="recruitment-status">
            {translateText("jpa_status_accepted")}
          </p>
        );
      }
    }
    if (props.IsProject) {
      if (props.Details.project.recruitmentStatus === null) {
        return (
          <p className="recruitment-status not-started">
            {translateText("not_started")}
          </p>
        );
      } else if (props.Details.project.recruitmentStatus === "IN_PROGRESS") {
        return (
          <p className="recruitment-status in-progress-item">
            {translateText("in_progress")}
          </p>
        );
      } else if (props.Details.project.recruitmentStatus === "NEW") {
        return (
          <p className="recruitment-status new-item">{translateText("new")}</p>
        );
      } else if (props.Details.project.recruitmentStatus === "POPULAR") {
        return (
          <p className="recruitment-status popular-item">
            {translateText("popular")}
          </p>
        );
      } else if (props.Details.project.recruitmentStatus === "ACCEPTED") {
        return (
          <p className="recruitment-status">
            {translateText("jpa_status_accepted")}
          </p>
        );
      }
    }
    if (props.IsActivity) {
      if (props.Details.activity.recruitmentStatus === null) {
        return (
          <p className="recruitment-status not-started">
            {translateText("not_started")}
          </p>
        );
      } else if (props.Details.activity.recruitmentStatus === "IN_PROGRESS") {
        return (
          <p className="recruitment-status in-progress-item">
            {translateText("in_progress")}
          </p>
        );
      } else if (props.Details.activity.recruitmentStatus === "NEW") {
        return (
          <p className="recruitment-status new-item">{translateText("new")}</p>
        );
      } else if (props.Details.activity.recruitmentStatus === "POPULAR") {
        return (
          <p className="recruitment-status popular-item">
            {translateText("popular")}
          </p>
        );
      } else if (props.Details.activity.recruitmentStatus === "ACCEPTED") {
        return (
          <p className="recruitment-status">
            {translateText("jpa_status_accepted")}
          </p>
        );
      }
    }
  };
  const displayDescription = () => {
    let Desc;
    if (props.IsJob) {
      Desc = props.Details.position.description;
    } else if (props.IsProject) {
      Desc = props.Details.project.description;
    } else {
      Desc = props.Details.activity.description;
    }

    if (Desc === undefined || Desc === null) {
      return null;
    } else {
      // if desc.length < 360, no need to render show more
      if (Desc.length < 360) {
        return (
          <span>
            {Desc}
          </span>);
      }

      return (
        <Fragment>
          <div className="description-wrapper" ref={DescriptionWrapperRef}>
            <div className="description-wrapper-inner">
              <span ref={DescriptionRef}>
                {ShowMore ? Desc : Desc.slice(0, 360)}
              </span>

              {!ShowMore ? <span>...</span> : null}

              {ShowMore ? (
                  <p className="show-more" onClick={() => setShowMore(prev => !prev)}>
                    Show less <i className="feather-chevron-up"></i>
                  </p>
              ) : (
                  <p className="show-more" onClick={() => setShowMore(prev => !prev)}>
                    Show more <i className="feather-chevron-down"></i>
                  </p>
              )}
            </div>
          </div>
        </Fragment>
      )
    }
  };
  const closeMobileFilters = () => {
    setMobileFilterIsOpen(false);
  };
  const clearMobileFilters = () => {
    if (document.getElementById("status-clear") !== null) {
      document.getElementById("status-clear").click();
    }
    if (document.getElementById("location-clear") !== null) {
      document.getElementById("location-clear").click();
    }
  };
  const applyMobileFilters = () => {
    setMobileFilterIsOpen(false);
  };
  const displayMobileFilters = () => {
    setMobileFilterIsOpen(true);
  };
  const handleItemTitle = () => {
    if (props.IsJob) {
      return props.Details.position.title;
    } else if (props.IsProject) {
      return props.Details.project.title;
    } else {
      return props.Details.activity.title;
    }
  };
  const handleItemLocation = () => {
    if (props.IsJob) {
      return props.Details.position.workCity;
    } else if (props.IsProject) {
      return props.Details.project.workCity;
    } else {
      return props.Details.activity.workCity;
    }
  };
  const goBack = () => {
    if (props.IsJob) {
      document.getElementById("back-to-jobs").click();
    } else if (props.IsProject) {
      document.getElementById("back-to-projects").click();
    } else {
      document.getElementById("back-to-activities").click();
    }
  };
  const toggleSaveItem = () => {
    let Data = {};
    let ReqURL;
    if (props.IsJob) {
      Data.positionId = props.Details.position.id;
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/bookmark";
    } else if (props.IsProject) {
      Data.projectId = props.Details.project.id;
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/bookmark";
    } else {
      Data.activityId = props.Details.activity.id;
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/bookmark";
    }

    if (
      document
        .getElementById("jpa-save-btn")
        .classList.contains("saved-icon-animated") ||
      document
        .getElementById("jpa-save-btn")
        .classList.contains("saved-icon-nonanimated")
    ) {
      document
        .getElementById("jpa-save-btn")
        .classList.remove("saved-icon-animated");
      document
        .getElementById("jpa-save-btn")
        .classList.remove("saved-icon-nonanimated");
    } else {
      document
        .getElementById("jpa-save-btn")
        .classList.add("saved-icon-animated");
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
        if (
          document
            .getElementById("jpa-save-btn")
            .classList.contains("saved-icon-animated")
        ) {
          document
            .getElementById("jpa-save-btn")
            .classList.remove("saved-icon-animated");
        } else {
          document
            .getElementById("jpa-save-btn")
            .classList.add("saved-icon-animated");
        }
      });
  };
  const toggleTabs = (TabId) => {
    if (TabId === "deleted") {
      props.ShowDeleted();
      document.getElementById("saved-only").style.display = "none";
      document
        .getElementById("indicator")
        .classList.add("indicator-translated");
      document.getElementById("deleted").classList.add("active-tab");
      document.getElementById("active").classList.remove("active-tab");
      document.getElementById("active-candidates").style.display = "none";
      document.getElementById("deleted-candidates").style.display = "flex";
      document.getElementById("deleted-candidates").classList.add("translated");
      document
        .getElementById("active-candidates")
        .classList.remove("translated");
      setTimeout(() => {
        document
          .getElementById("deleted-candidates")
          .classList.remove("translated");
      }, 500);
    } else {
      props.ShowActive();
      document.getElementById("saved-only").style.display = "flex";
      document
        .getElementById("indicator")
        .classList.remove("indicator-translated");
      document.getElementById("deleted").classList.remove("active-tab");
      document.getElementById("active").classList.add("active-tab");
      document.getElementById("active-candidates").style.display = "flex";
      document.getElementById("deleted-candidates").style.display = "none";
      document
        .getElementById("deleted-candidates")
        .classList.remove("translated");
      document.getElementById("active-candidates").classList.add("translated");
      setTimeout(() => {
        document
          .getElementById("active-candidates")
          .classList.remove("translated");
      }, 500);
    }
  };
  return (
    <div className="jpa-details-head">
      {ModalIsOpen ? (
        <SkillsModal
          Close={() => setModalIsOpen(false)}
          Skills={Skills}
          Title={handleItemTitle()}
          Location={handleItemLocation()}
          LangData={props.LangData}
        />
      ) : null}
      {window.innerWidth < 450 ? (
        <div
          className="mobile-filters-overlay is-mobile"
          hidden={MobileFilterIsOpen ? false : true}
        >
          <section className="mobile-filters-head">
            <i className="feather-x" onClick={() => closeMobileFilters()}></i>
            <p>{translateText("filters")}</p>
            <span onClick={() => clearMobileFilters()}>
              {translateText("clear")}
            </span>
          </section>
          <section className="mobile-filters-body">
            <SimpleFilter
              Name={translateText("status")}
              Id="status"
              ChangeHandler={() => null}
              Options={props.StatusOptions}
              IsWithId
            />
            <SimpleFilter
              Name={translateText("location")}
              Id="location"
              ChangeHandler={() => null}
              IsWithId
              Options={props.Locations}
            />
            <SimpleFilter
              Name={translateText("location")}
              Id="location"
              ChangeHandler={() => null}
              IsWithId
              Options={props.IdentityFilterOptions}
            />
          </section>
          <section className="mobile-filters-footer">
            <div onClick={() => applyMobileFilters()}>
              {translateText("apply_filters")}
            </div>
          </section>
        </div>
      ) : null}
      <section className="head-top">
        <NavLink to="/vacancies" id="back-to-jobs"></NavLink>
        <NavLink to="/projects" id="back-to-projects"></NavLink>
        <NavLink to="/activities" id="back-to-activities"></NavLink>
        <i className="feather-arrow-left" onClick={() => goBack()}></i>
        <h1 className="head-title">{translateText("candidates")}</h1>
        {window.innerWidth > 450 ? (
          <span className="export-btn" onClick={() => props.ToggleExport()}>
            <i className="feather-download"></i>
            {translateText("export_data_to_excel")}
          </span>
        ) : (
          <span className="export-btn" onClick={() => props.ToggleExport()}>
            <i className="feather-download"></i>
            {translateText("export")}
          </span>
        )}
      </section>
      <section className="jpa-details-head-content">
        <div className="text-details">
          {displayTitle()}
          {displayGlobalCode()}
          {displayLocation()}
          <p className="jpa-desc">{displayDescription()}</p>
        </div>
        <div className="other-details">
          <button
            className={
              props.Details.bookmarked
                ? "bookmark-btn saved-icon-nonanimated"
                : "bookmark-btn"
            }
            id="jpa-save-btn"
            onClick={() => toggleSaveItem()}
          ></button>
          <section className="other-details-head">
            {displayStatus()}
            <span className="available-since">
              <i className="feather-calendar"></i>
              {translateText("available_since")}
              <p className="date-available">
                {formatDate(
                  new Date(props.Details.createdTime).getTime(),
                  "dd-MM-y"
                )}
              </p>
            </span>
          </section>
          <section className="required-skills">
            <h1 className="skills-scetion-title">
              {translateText("all_required_skills")} {"(" + Skills.length + ")"}
            </h1>
            <section className="skills-wrapper">
              {[...Skills].splice(0, 9).map((Skill) => (
                <span className="skill-item">{Skill}</span>
              ))}
              {Skills.length === 0 ? null : (
                <button
                  className="more-skills"
                  onClick={() => setModalIsOpen(true)}
                >
                  <i className="feather-more-vertical"></i>
                </button>
              )}
            </section>
          </section>
        </div>
      </section>
      {window.innerWidth <= 450 ? (
        <SearchInput
          OnChange={() => props.ToggleFetchCandidates()}
          Placeholder={translateText("search_candidate_input_placeholder")}
        />
      ) : null}
      {window.innerWidth > 450 ? (
        <div className="filters-holder candidates-filters is-desktop">
          <section className="filters">
            <SearchInput
              OnChange={() => props.ToggleFetchCandidates()}
              Placeholder={translateText("search_candidate_input_placeholder")}
            />
            <SimpleFilter
              Name={translateText("status")}
              Id="status"
              IsWithId
              ChangeHandler={() => props.ToggleFetchCandidates()}
              Options={props.StatusOptions}
            />
            <SimpleFilter
              Name={translateText("location")}
              Id="location"
              ChangeHandler={() => props.ToggleFetchCandidates()}
              IsWithId
              Options={props.Locations}
            />
            <SimpleFilter
              Name={translateText("identity")}
              Id="identity"
              ChangeHandler={() => props.ToggleFetchCandidates()}
              IsWithId
              Options={props.IdentityFilterOptions}
            />
          </section>
        </div>
      ) : null}
      <div className="saved-only" id="saved-only">
        <img alt="" src={BookmarkIcon} />
        <p>{translateText("saved_items_only")}</p>
        <Switch ChangeEvent={() => props.ToggleFetchCandidates()} Id="saved" />
        <section
          onClick={() => displayMobileFilters()}
          className="mobile-filters is-mobile"
        >
          <i className="feather-filter"></i>
          <p>{translateText("filters")}</p>
        </section>
      </div>
      <div className="tabs">
        <section className="tabs-wrapper">
          <span
            className="tab-item active-tab"
            id="active"
            onClick={() => toggleTabs("active")}
          >
            {translateText("active")}
          </span>
          <span
            className="tab-item"
            id="deleted"
            onClick={() => toggleTabs("deleted")}
          >
            {translateText("deleted")}
          </span>
          <span className="indicator" id="indicator"></span>
        </section>
      </div>
    </div>
  );
};

export default Head;
